import { Inject, Injectable } from '@angular/core';
import { ApiService, API_SERVICE } from 'ng-upgrade-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class SelectorService {
  constructor(@Inject(API_SERVICE) private apiService: ApiService) {
  }

  GetInstitutionProductListGroupByBrand(institutionId: string, territoryId: string): Observable<any> {
    // @ts-ignore
    return this.apiService.getJson(`Selector/GetInstitutionProductListGroupByBrand/${institutionId}/${territoryId}`);
  }

  GetNeworkProductOptionList(institutionId: string, territoryId: string, type: string) {
    return this.apiService.getJson(`RepNetworkSetting/GetNeworkProductOptionList/${territoryId}/${institutionId}/${type}`);
  }

  GetNeworkProductChildrenOptionList(institutionId: string, territoryId: string, parentId: string, type: string) {
    return this.apiService.getJson(`RepNetworkSetting/GetNeworkProductChildrenOptionList/${territoryId}/${institutionId}/${parentId}/${type}`);
  }

  GetProductOptionList(type: string): Observable<any> {
    // @ts-ignore
    return this.apiService.getJson(`Selector/GetProductOptionList/${type}`);
  }

  GetChildrenProductOptionList(model: any): Observable<any> {
    // @ts-ignore
    return this.apiService.postJson(`Selector/GetChildrenProductOptionList`, {
      body: model
    });
  }

  GetOptionList(moduleCode: string): Observable<any> {
    return this.apiService.getJson(`Selector/GetOptionList/${moduleCode}`);
  }

  GetOptionListByTag(moduleCode: string, tag1: string): Observable<any> {
    return this.apiService.getJson(`Selector/GetOptionListByTag/${moduleCode}/${tag1}`);
  }

  GetTypeList(moduleCode: string): Observable<any> {
    return this.apiService.getJson(`Selector/GetTypeList/${moduleCode}`);
  }


  GetParaValueUrl(moduleCode: string): Observable<any> {
    return this.apiService.getJson(`Selector/GetParaValueUrl/${moduleCode}`);
  }

  GetLastLoginTime(): Observable<any> {
    return this.apiService.getJson(`Selector/GetLastLoginTime`);
  }


}
